import {
  generateUserAgentHeader,
  getRegistrationEndpoint,
  getTermsOfUseId,
  urls,
} from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';

export const registerPatient = async (
  register: Register,
  osType: string,
  osVersion: string,
  app: App,
  appVersion: string,
  country: string,
  language: string
) => {
  await mediator.request<ApiResponse<void>>('api:invoke', {
    method: 'POST',
    url: urls.apiUrl + getRegistrationEndpoint(app),
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
    },
    data: {
      Email: register.email,
      Password: register.password,
      Country: country,
      FirstName: register.firstName,
      LastName: register.lastName,
      DateOfBirth: register.dateOfBirth,
      Language: language,
      GuardianFirstName: register.guardianFirstName,
      GuardianLastName: register.guardianLastName,
      consents: [
        {
          id: getTermsOfUseId(app),
          action: 'accept',
        },
        {
          id: 'pp',
          action: 'accept',
        },
      ],
    },
  });
};

export const updatePhone = async (
  updatePhoneData: UpdatePhoneRequest,
  osType: string,
  osVersion: string,
  app: string,
  appVersion: string
) => {
  if (!updatePhoneData.userID) {
    throw new Error('User ID is required to update phone');
  }

  await mediator.request<ApiResponse<void>>('api:invoke', {
    method: 'PATCH',
    url: `${urls.apiUrl}accounts/${updatePhoneData.userID}/phone`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
    },
    data: {
      phone: updatePhoneData.phone,
    },
  });
};

export const updateEmail = async (
  updateEmailData: UpdateEmailRequest,
  osType: string,
  osVersion: string,
  app: string,
  appVersion: string
) => {
  if (!updateEmailData.userID) {
    throw new Error('User ID is required to update email');
  }

  await mediator.request<ApiResponse<void>>('api:invoke', {
    method: 'PATCH',
    url: `${urls.apiUrl}accounts/${updateEmailData.userID}/email`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
    },
    data: {
      email: updateEmailData.email,
    },
  });
};

export const updatePassword = async (
  updatePasswordData: UpdatePasswordRequest,
  osType: string,
  osVersion: string,
  app: string,
  appVersion: string
) => {
  if (!updatePasswordData.userID) {
    throw new Error('User ID is required to update password');
  }

  await mediator.request<ApiResponse>('api:invoke', {
    method: 'PATCH',
    url: `${urls.apiUrl}accounts/${updatePasswordData.userID}/password`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
    },
    data: {
      password: updatePasswordData.newPassword,
      secondaryAuthentication: {
        email: updatePasswordData.emailConfirmation,
        password: updatePasswordData.currentPassword,
      },
    },
  });
};

export const getPatient = async (
  patientId: string,
  osType = 'none',
  osVersion = 'none',
  app = 'none',
  appVersion = 'none'
) => {
  const result = await mediator.request<ApiResponse<Patient>>('api:invoke', {
    method: 'GET',
    url: `${urls.apiUrl}patients/${patientId}`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};
